/**
 * Transitional screen if something still navigates to /redirecting.
 * Unauthenticated visitors normally hard-navigate to account-web via
 * location.replace and never land here.
 */
import { AuthTransitionScreen } from "@/ui/components/AuthTransitionScreen";

export function RedirectingPage() {
  return <AuthTransitionScreen message="Redirecting to sign in…" />;
}
